import React from "react";
import Meta from "./../components/Meta";
import AuthSection from "./../components/Auth/AuthSection";
import { useRouter } from "utilities/router";

function AuthPage(props) {
  const router = useRouter();

  return (
    <>
      <Meta title="Start Using Sound" />

      <AuthSection
        type={router.query.type}
        providers={["google"]}
        afterAuthPath={"/registration"}
      />
    </>
  );
}

export default AuthPage;
